export const passwordPolicy = {
    minLength: 12,
    minLowerCase: 1,
    minUpperCase: 1,
    minDigits: 1,
    minSpecialCharacters: 1
}
